import { TagOutlined } from '@ant-design/icons'

import { RouteItem } from '@eastcoal/router/types/route'

import {
  LISTING_CREATE_PAGE_PATH,
  LISTING_EDIT_PAGE_PATH,
  LISTING_LIST_PAGE_PATH
} from './constants/path'
import {
  LISTING_LIST_PAGE_UUID,
  LISTING_MANAGE_ACTION_UUID
} from './constants/uuid'

export const listingRoute: RouteItem = {
  title: '商品挂牌',
  icon: <TagOutlined />,
  hideChildrenInMenu: true,
  children: [
    {
      title: '挂牌列表',
      path: LISTING_LIST_PAGE_PATH,
      uuid: LISTING_LIST_PAGE_UUID,
      Component: () => import('./List/index')
    },
    {
      title: '管理挂牌',
      uuid: LISTING_MANAGE_ACTION_UUID,
      children: [
        {
          title: '新增挂牌',
          path: LISTING_CREATE_PAGE_PATH,
          Component: () => import('./Create')
        },
        {
          title: '编辑挂牌',
          path: LISTING_EDIT_PAGE_PATH,
          Component: () => import('./Edit')
        }
      ]
    }
  ]
}
